import React from 'react'
import './Privacy.css'

const Privacy = () => {
    return (
        <div>
            <div className="privacy-header">
                <h1>Privacy Policy</h1>
            </div>
            <div className="privacy-container">
                <div className="privacy-section">
                    <p className="highlight">
                        Aizo Teq Solutions Private Limited ("we", "our", "us", or "Aizo") has developed the Aizo Plug EV Charging application
                        ("the App", "our Service", "the Service") to provide electric vehicle charging solutions. This privacy policy
                        explains how we collect, use, protect, and share your information when you use our Service.
                    </p>
                </div>
                <div class="section">
                    <h2>Introduction</h2>
                    <p>
                        This privacy policy is designed to help you understand what information we collect, why we collect it,
                        and how you can manage your information. By downloading, installing, or using our App, you agree to
                        the collection and use of information as described in this policy.
                    </p>
                </div>
                <div class="section">
                    <h2>Information We Collect</h2>
                    <p>To provide you with our EV charging services, we collect:</p>
                    <ul>
                        <li><strong>Personal Information:</strong> Name, email address, phone number, billing address</li>
                        <li><strong>Vehicle Information:</strong> Vehicle make, model, registration number, charging
                            specifications</li>
                        <li><strong>Payment Information:</strong> Payment card details, transaction history, billing preferences
                        </li>
                        <li><strong>Account Information:</strong> Login credentials, user preferences, profile settings</li>
                        <li><strong>Usage Data:</strong> Charging session history, power consumption, preferred charging
                            locations</li>
                    </ul>
                </div>
                <div class="section">
                    <h2>Location Data and Navigation Services</h2>
                    <p>Our app collects and processes location data to provide essential EV charging services:</p>
                    <ul>
                        <li><strong>Real-time Navigation:</strong> Turn-by-turn directions to charging stations</li>
                        <li><strong>Charging Station Discovery:</strong> Location-based search for nearby charging points</li>
                        <li><strong>Route Planning:</strong> Optimal route calculation considering charging stops</li>
                        <li><strong>Range Estimation:</strong> Vehicle range calculation based on current location and charging
                            stations</li>
                        <li><strong>Station Availability:</strong> Real-time updates on charging station status</li>
                    </ul>
                    <p class="highlight">
                        Location data is collected both in foreground and background modes to provide uninterrupted navigation
                        and charging station discovery services. You can control location permissions through your device
                        settings.
                    </p>
                </div>
                <div class="section">
                    <h2>Charging Session Data</h2>
                    <p>During charging sessions, we collect:</p>
                    <ul>
                        <li>Start and end times of charging sessions</li>
                        <li>Energy consumption data</li>
                        <li>Charging speed and power levels</li>
                        <li>Payment transactions and billing information</li>
                        <li>Station performance metrics</li>
                    </ul>
                </div>
                <div class="section">
                    <h2>How We Use Your Information</h2>
                    <p>We use the collected information to:</p>
                    <ul>
                        <li>Process and manage charging sessions</li>
                        <li>Provide accurate navigation services</li>
                        <li>Generate charging history and usage reports</li>
                        <li>Process payments and maintain billing records</li>
                        <li>Improve our charging network and services</li>
                        <li>Provide customer support and technical assistance</li>
                        <li>Send important service updates and notifications</li>
                    </ul>
                </div>
                <div class="section">
                    <h2>Data Security Measures</h2>
                    <p class="highlight">
                        We implement robust security measures to protect your personal information, including:
                    </p>
                    <ul>
                        <li><strong>Encryption:</strong> All data transmission between your device and our servers uses
                            industry-standard SSL/TLS encryption</li>
                        <li><strong>Secure Storage:</strong> Your payment information is stored using PCI-DSS compliant systems
                        </li>
                        <li><strong>Access Controls:</strong> Strict employee access controls and authentication mechanisms</li>
                        <li><strong>Regular Audits:</strong> Periodic security audits and vulnerability assessments</li>
                        <li><strong>Data Backups:</strong> Regular encrypted backups of all critical data</li>
                    </ul>
                </div>
                <div class="section">
                    <h2>Third-Party Integration</h2>
                    <p>Our service integrates with various third-party services to enhance your EV charging experience:</p>
                    <ul>
                        <li><strong>Payment Processors:</strong> For secure payment processing</li>
                        <li><strong>Maps Services:</strong> For navigation and location services</li>
                        <li><strong>Analytics Providers:</strong> To improve our service quality</li>
                        <li><strong>Cloud Service Providers:</strong> For data storage and processing</li>
                    </ul>
                    <p>Each third-party service operates under their own privacy policy, which we encourage you to review.</p>
                </div>
                <div class="section">
                    <h2>Third-Party Services</h2>
                    <p>Our app uses third-party services that may collect information used to identify you.</p>
                    <p>You can review the privacy policies of our third-party service providers here:</p>
                    <ul>
                        <li><a href="https://policies.google.com/privacy" target="_blank">Google Play Services</a></li>
                    </ul>
                </div>
                <div class="section">
                    <h2>Log Collection</h2>
                    <p class="highlight">
                        We collect logs of your usage of our service for debugging and improvement purposes. These logs may
                        include:
                    </p>
                    <ul>
                        <li>Device information (model, OS version)</li>
                        <li>App version and configuration</li>
                        <li>Time and date of usage</li>
                        <li>Error reports and crash analytics</li>
                        <li>Feature usage patterns</li>
                        <li>Performance metrics</li>
                    </ul>
                    <p>We handle these logs in accordance with our privacy policy and do not share them with third parties
                        except as necessary for providing and improving our service.</p>
                </div>
                <div class="section">
                    <h2>Children's Privacy</h2>
                    <p class="highlight">
                        Our Services do not knowingly collect personally identifiable
                        information from children
                    </p>
                    <ul>
                        <li>If you are a parent or guardian and you are aware that your child has provided us with personal
                            information, please contact us immediately</li>
                        <li>We will take necessary steps to ensure such information is removed from our records</li>
                    </ul>
                </div>
                <div class="section">
                    <h2>Intellectual Property Rights</h2>
                    <p class="highlight">
                        All intellectual property rights related to the Aizo Plug EV Charging app, including but not limited to:
                    </p>
                    <ul>
                        <li>Software code and architecture</li>
                        <li>User interface and design elements</li>
                        <li>Logos and branding materials</li>
                        <li>Content and documentation</li>
                        <li>Patents, trademarks, and trade secrets</li>
                    </ul>
                    <p>Are owned by AIZO TEQ SOLUTIONS PVT LTD. Any unauthorized use, reproduction, or distribution is strictly
                        prohibited.</p>
                </div>
                <div class="section">
                    <h2>Your Rights and Controls</h2>
                    <p>You have the following rights regarding your personal data:</p>
                    <ul>
                        <li><strong>Access:</strong> Request a copy of your personal data</li>
                        <li><strong>Correction:</strong> Update or correct inaccurate data</li>
                        <li><strong>Deletion:</strong> Request deletion of your account and associated data</li>
                        <li><strong>Portability:</strong> Receive your data in a structured, common format</li>
                        <li><strong>Restriction:</strong> Limit how we use your data</li>
                    </ul>
                </div>
                <div class="section">
                    <h2>Data Retention</h2>
                    <p>We retain your information for the following periods:</p>
                    <ul>
                        <li><strong>Account Information:</strong> As long as your account is active</li>
                        <li><strong>Charging History:</strong> 12 months for billing and analysis</li>
                        <li><strong>Payment Information:</strong> As required by financial regulations</li>
                        <li><strong>Usage Logs:</strong> 6 months for technical support</li>
                    </ul>
                </div>
                <div class="section">
                    <h2>App Permissions</h2>
                    <p>Our app requires the following permissions to function properly:</p>
                    <ul>
                        <li><strong>Location Services:</strong> For finding charging stations and navigation</li>
                        <li><strong>Network Access:</strong> For real-time updates and communication</li>
                        <li><strong>Camera:</strong> For QR code scanning at charging stations</li>
                        <li><strong>Bluetooth:</strong> For communication with charging stations</li>
                        <li><strong>Storage:</strong> For saving offline maps and user preferences</li>
                    </ul>
                </div>
                <div class="section">
                    <h2>International Data Transfers</h2>
                    <p class="highlight">
                        Your information may be transferred to and processed in countries other than your own.
                        We ensure appropriate safeguards are in place through:
                    </p>
                    <ul>
                        <li>Standard contractual clauses</li>
                        <li>Data processing agreements</li>
                        <li>Compliance with international data protection laws</li>
                    </ul>
                </div>
                <div class="section">
                    <h2>Incident Response</h2>
                    <p>In the event of a data breach, we will:</p>
                    <ul>
                        <li>Notify affected users within 72 hours</li>
                        <li>Provide details of the breach and data affected</li>
                        <li>Take immediate steps to secure your information</li>
                        <li>Work with authorities as required</li>
                    </ul>
                </div>
                <div class="section">
                    <h2>Cookie Policy</h2>
                    <p>We use the following types of cookies:</p>
                    <ul>
                        <li><strong>Essential Cookies:</strong> Required for basic app functionality</li>
                        <li><strong>Performance Cookies:</strong> To analyze app usage and performance</li>
                        <li><strong>Functional Cookies:</strong> To remember your preferences</li>
                        <li><strong>Targeting Cookies:</strong> For marketing purposes (with consent)</li>
                    </ul>
                </div>
                <div class="section">
                    <h2>Changes to This Privacy Policy</h2>
                    <p>
                        We may update this privacy policy periodically to reflect changes in our practices or for legal,
                        operational, or regulatory reasons. We will notify you of any material changes through the App
                        or via email.
                    </p>
                </div>

                  {/* ================= TERMS & CONDITIONS ================= */}
                <div className="section" id="terms-conditions">
                    <h2>Terms & Conditions</h2>

                    <p>
                        By using the Aizo Plug EV Charging platform, you agree to the following terms.
                    </p>

                    <ul>
                        <li>
                            <strong>Service Usage:</strong> Users can locate chargers, start sessions,
                            and make payments through the app.
                        </li>
                        <li>
                            <strong>Account Responsibility:</strong> Users are responsible for their
                            login credentials.
                        </li>
                        <li>
                            <strong>Service Availability:</strong> Charging depends on network and
                            station availability.
                        </li>
                        <li>
                            <strong>Misuse:</strong> Unauthorized access or tampering is prohibited.
                        </li>
                        <li>
                            <strong>Governing Law:</strong> These terms are governed by Indian law.
                        </li>
                    </ul>
                </div>

                {/* ================= REFUND & CANCELLATION ================= */}
                <div className="section" id="refund-cancellation">
                    <h2>Refund & Cancellation Policy</h2>

                    <p>
                        This policy applies to all charging sessions initiated via
                        the Aizo Plug EV Charging application.
                    </p>

                    <ul>
                        <li>
                            <strong>Charging Not Started:</strong>
                            If the charging machine does not start due to technical issues,
                            the deducted amount will be refunded automatically.
                        </li>

                        <li>
                            <strong>Charging Started:</strong>
                            Once charging has started, consumed energy charges are non-refundable.
                        </li>

                        <li>
                            <strong>Remaining Balance:</strong>
                            Any unused balance after stopping the session will be refunded
                            automatically.
                        </li>

                        <li>
                            <strong>Wallet Payments:</strong>
                            Wallet refunds will be credited back to the in-app wallet.
                        </li>

                        <li>
                            <strong>Refund Time:</strong>
                            Refunds are processed within 5–7 working days.
                        </li>
                    </ul>

                    <p className="highlight">
                        For refund issues, contact
                        <a href="mailto:info@aizoplug.com"> info@aizoplug.com</a>
                    </p>
                </div>
                
                <div className="section contact-section">
    <h2>Contact Us</h2>
    <p style={{ textAlign: 'center', opacity: 0.9 }}>
        If you have questions about this Privacy Policy or our privacy practices, please reach out to us:
    </p>

    <div className="contact-details">
        <div className="contact-card">
            <div className="contact-item">
                <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path
                        d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                </svg>
                <div className="contact-text">
                    <span className="contact-label">Email</span>
                    <a href="mailto:info@aizoplug.com">info@aizoplug.com</a> <br />
                    <a href="mailto:aizoplug@gmail.com">aizoplug@gmail.com</a>
                </div>
            </div>
        </div>
        {/* Other contact cards */}


                <div class="contact-card">
                    <div class="contact-item">
                        <svg class="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                            <path
                                d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
                        </svg>
                        <div class="contact-text">
                            <span class="contact-label">Phone</span>
                            <a href="tel:+918012523333">+91 801 252 3333 (India)</a>
                        </div>
                    </div>
                </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Privacy